"use client";

import { BRAND_TAGLINE, BRAND_TITLE } from "@/lib/brand";

const Footer = () => {
  return (
    <footer className="dida-footer border-t border-pink-200/50">
      <div className="container mx-auto px-4 py-5">
        <p className="text-center text-sm font-medium text-foreground/80">
          {BRAND_TITLE}
        </p>
        <p className="mt-1 text-center text-xs text-muted-foreground">
          {BRAND_TAGLINE}
        </p>
      </div>
    </footer>
  );
};

export default Footer;
